import { Icons, Row, Stack, Text } from '..'

export function Notification({ title, content, children, color = 'primary' }) {
  return (
    <Row alignItems="center" spacing={0} width="90%">
      <Icons.NotificationImportant sx={{ fontSize: '3rem', justifyContent: 'center' }} color={color} />
      <Stack spacing={2} sx={{ flex: 1, alignItems: 'center', textAlign: 'center' }}>
        {title && <Text.H5 data-testid="profileWarningMessage">{title}</Text.H5>}
        {typeof content === 'string' ? <Text.Body>{content}</Text.Body> : content}
        {children && <Row sx={{ justifyContent: { md: 'center' } }}>{children}</Row>}
      </Stack>
    </Row>
  )
}
